import React from 'react';
import { Check } from 'lucide-react';
import { credibilityBuilders, marketingImages } from '../../data/mock';

const CredibilitySection = () => {
  return (
    <section className="py-24 bg-teal-600">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Faith-Based Image */}
          <div className="flex justify-center order-2 lg:order-1">
            <img 
              src={marketingImages.faithBased} 
              alt="Faith-Based Approach"
              className="w-full max-w-md rounded-2xl shadow-2xl"
            />
          </div>

          {/* Credibility List */}
          <div className="order-1 lg:order-2">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Why You Can Trust This Guide
            </h2>
            <p className="text-white/80 text-lg mb-8">
              Built on real data, practical experience, and faith-based principles
            </p>

            <div className="space-y-4">
              {credibilityBuilders.map((item, idx) => (
                <div key={idx} className="flex items-start gap-4">
                  <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-4 h-4 text-teal-600" />
                  </div>
                  <span className="text-white text-lg">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CredibilitySection;
